import React from "react";
import { inject, observer } from "mobx-react";
import ReactGA from "react-ga";
import {
  Route,
  Switch,
  Redirect,
  Router,
  BrowserRouter,
} from "react-router-dom";
import createHistory from "history/createBrowserHistory";
import { SarcopeniaDemoDashboard } from "pages/demo-dashboard/";
import Config from "config";
import RedirectPage from "component/redirect/RedirectPage";

ReactGA.initialize("UA-172653642-01");
const history = createHistory();
history.listen((location, action) => {
  ReactGA.pageview(location.pathname + location.search);
});

function isTokenExpired(token) {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1])); // 페이로드 디코딩
    const currentTime = Math.floor(Date.now() / 1000); // 현재 시간 (초)
    // console.log("payload: ", payload);
    // console.log("currentTime: ", currentTime);
    if (payload.exp < currentTime) {
      localStorage.removeItem("token");
    }
  } catch (e) {
    return true; // 파싱 실패 시도 만료로 간주
  }
}

@inject("authStore")
@observer
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserLoaded: false,
      isCreditEnough: false,
    };
    this.handleMessage = this.handleMessage.bind(this);
  }

  componentDidMount() {
    localStorage.removeItem("token");
    // window.addEventListener("message", this.handleMessage, false);
    const token = localStorage.getItem("token");
    if (token) {
      // console.log("token: ", token);
      isTokenExpired(token)
      this.verifyToken(token);
    } else {
      window.addEventListener("message", this.handleMessage, false);
      // console.log("토큰이 없습니다. 부모 창으로부터 메시지를 기다립니다.");
    }
  
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage, false);
  }

  handleMessage(event) {
    // console.log("📩 받은 메시지:", event.data, "from", event.origin);

    const allowedOrigins = [
      `${process.env.REACT_APP_HOMEPAGE_URL}`,
      `${process.env.REACT_APP_SLICE_FRONT_URL}`,
      `${process.env.REACT_APP_SLICE_BACK_URL}`
    ];

    if (!allowedOrigins.includes(event.origin)) 
      {
        // console.warn("Origin 불일치:", event.origin);
        return;
      }

    const { token } = event.data;
    if (token) {
      // ✅ 부모에게 받은 거 확인했다고 알림
      event.source.postMessage({ ack: true }, event.origin);
      localStorage.removeItem("token");
      // ✅ 토큰은 단 한 번만 처리하도록 조건
      if (!localStorage.getItem("token")) {
        localStorage.setItem("token", token);
        this.verifyToken(token);
      }
    }
  }

  verifyToken(token) {
    if (this.props.authStore) {
      this.props.authStore.setToken(token);
      
      fetch(`${process.env.REACT_APP_HOMEPAGE_URL}/api/userinfo`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error("API 호출 실패");
          return res.json();
        })
        .then((userData) => {
          this.props.authStore.setUserID(userData.email);
          this.props.authStore.setCredit(userData.credit);
          // console.log("user information: ", userData.email, userData.credit)
          this.setState({
            isLoading: false,
            isUserLoaded: true,
            isCreditEnough: userData.credit > 0, // 크레딧 확인
          });
        })
        .catch((error) => {
          console.error("사용자 정보 가져오기 실패:", error);
          this.setState({ isLoading: false, isUserLoaded: false });
        });
    }
  }

  render() {
    const { isLoading, isCreditEnough, isUserLoaded } = this.state;
    const { authStore } = this.props;
    const isSignedIn = !!authStore.getToken();

    if (isLoading) {
      return (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "24px",
          fontWeight: "bold",
          color: "#e3e2e3"
        }}>
          LOADING...
        </div>
      );
    }

    return (
      <Router history={history}>
        
          <Switch>
            <Route render={() =>
              isSignedIn && isUserLoaded && isCreditEnough ? (
                <SarcopeniaDemoDashboard />
              ) : (
                // 조건 불충족 시 아무것도 렌더링하지 않음
                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#e3e2e3"
                }}>
                  LOADING...
                </div>
              )
            } />
          </Switch>
        
      </Router>
    );
  }
}

export default App;
